import type { RoundingRule } from '@gpa-scales/shared-types';

export function applyRounding(value: number, rule: RoundingRule): number {
  if (rule.mode === 'none') return value;

  const places = rule.mode === 'decimal_1' ? 1 : rule.mode === 'decimal_2' ? 2 : 3;
  const multiplier = Math.pow(10, places);

  switch (rule.method) {
    case 'truncate':
      return Math.floor(value * multiplier) / multiplier;
    case 'round_half_up':
      return Math.round(value * multiplier) / multiplier;
    case 'round_half_even': {
      const shifted = value * multiplier;
      const floored = Math.floor(shifted);
      const decimal = shifted - floored;
      if (decimal === 0.5) {
        return (floored % 2 === 0 ? floored : floored + 1) / multiplier;
      }
      return Math.round(shifted) / multiplier;
    }
    default:
      return value;
  }
}
